import dayjs from "dayjs";

const TableColumn = (
  isClient,
  selectedFilter = "Product",
  handleOpenNewTab,
) => {
  return [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (no) => no,
    },
    {
      title: "Client",
      dataIndex: "client_name",
      key: "client_name",
      hidden: selectedFilter === "Client",
      sorter: (a, b) => {
        if (a.client_name === null || a.client_name === "-") return 1;
        if (b.client_name === null || b.client_name === "-") return -1;
        return a.client_name.localeCompare(b.client_name);
      },
      render: (client_name) => {
        if (client_name === null || client_name === "-") {
          return "-";
        } else {
          return client_name;
        }
      },
    },
    {
      title: "Product",
      dataIndex: "product_name",
      key: "product_name",
      hidden: selectedFilter === "Product",
      sorter: (a, b) => {
        if (a.product_name === null || a.product_name === "-") return 1;
        if (b.product_name === null || b.product_name === "-") return -1;
        return a.product_name.localeCompare(b.product_name);
      },
      render: (product_name) => {
        if (product_name === null || product_name === "-") {
          return "-";
        } else {
          return product_name;
        }
      },
    },
    {
      title: "No. Pallet",
      dataIndex: "pallet_name",
      key: "pallet_name",
      sorter: (a, b) => {
        if (a.pallet_name === null || a.pallet_name === "-") return 1;
        if (b.pallet_name === null || b.pallet_name === "-") return -1;
        return a.pallet_name.localeCompare(b.pallet_name);
      },
      render: (pallet_name) => {
        if (pallet_name === null || pallet_name === "-") {
          return "-";
        } else {
          return pallet_name;
        }
      },
    },
    {
      title: "Posisi",
      dataIndex: "name",
      key: "name",
      hidden: isClient,
      sorter: (a, b) => {
        if (a.name === null || a.name === "-") return 1;
        if (b.name === null || b.name === "-") return -1;
        return a.name.localeCompare(b.name);
      },
      render: (name, record) => {
        if (!name || name === "-") return "-";

        return (
          <a
            href={`/#/detail-stock/${name}`}
            onClick={(e) => handleOpenNewTab(e, record)}
          >
            {name}
          </a>
        );
      },
    },
    {
      title: "Berat",
      dataIndex: "weight",
      key: "weight",
      sorter: (a, b) => {
        if (a.weight === null || a.weight === "-") return 1;
        if (b.weight === null || b.weight === "-") return -1;
        return a.weight - b.weight;
      },
      render: (weight) => {
        if (weight === null || weight === "-") {
          return "-";
        } else {
          return Math.round(weight) + " Kg";
        }
      },
    },
    {
      title: "Spesifikasi",
      dataIndex: "specification",
      key: "specification",
      sorter: (a, b) => {
        if (a.specification === null || a.specification === "-") return 1;
        if (b.specification === null || b.specification === "-") return -1;
        return a.specification.localeCompare(b.specification);
      },
      render: (specification) => {
        if (specification === null || specification === "-") {
          return "-";
        } else {
          return specification;
        }
      },
    },
    {
      title: "Tanggal Inbound",
      dataIndex: "received_at",
      key: "received_at",
      sorter: (a, b) => {
        if (a.received_at === null || a.received_at === "-") return 1;
        if (b.received_at === null || b.received_at === "-") return -1;
        return a.received_at.localeCompare(b.received_at);
      },
      render: (received_at) => {
        if (received_at === null || received_at === "-") {
          return "-";
        } else {
          return dayjs(received_at).format("DD-MM-YYYY");
        }
      },
    },
    {
      title: "Tanggal Outbound",
      dataIndex: "last_outbound_date",
      key: "last_outbound_date",
      sorter: (a, b) => {
        if (a.last_outbound_date === null || a.last_outbound_date === "-")
          return 1;
        if (b.last_outbound_date === null || b.last_outbound_date === "-")
          return -1;
        return a.last_outbound_date.localeCompare(b.last_outbound_date);
      },
      render: (last_outbound_date) => {
        if (last_outbound_date === null || last_outbound_date === "-") {
          return "-";
        } else {
          return dayjs(last_outbound_date).format("DD-MM-YYYY");
        }
      },
    },
    {
      title: "Lama Penyimpanan",
      dataIndex: "duration",
      key: "duration",
      sorter: (a, b) => {
        if (a.duration === null || a.duration === "-") return 1;
        if (b.duration === null || b.duration === "-") return -1;
        return a.duration - b.duration;
      },
      render: (duration) => {
        if (duration === null || duration === "-") {
          return "-";
        } else {
          return duration + " Hari";
        }
      },
    },
    {
      title: "Jumlah Pack",
      dataIndex: "quantity",
      key: "quantity",
      sorter: (a, b) => {
        if (a.quantity === null || a.quantity === "-") return 1;
        if (b.quantity === null || b.quantity === "-") return -1;
        return a.quantity - b.quantity;
      },
      render: (quantity) => {
        if (quantity === null || quantity === "-") {
          return "-";
        } else {
          return quantity;
        }
      },
    },
    {
      title: "Total Biaya",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => {
        if (a.amount === null || a.amount === "-") return 1;
        if (b.amount === null || b.amount === "-") return -1;
        return a.amount - b.amount;
      },
      render: (amount) => {
        if (amount === null || amount === "-") {
          return "-";
        } else {
          return "Rp " + amount.toLocaleString("id-ID");
        }
      },
    },
  ];
};

export default TableColumn;
